<seds-modal class="modal-error">
  <div content>
    <em class="material-icons modal-error__icon">clear</em>
    <br />
    <h2>{{ title }}</h2>
    <br>
    <span>{{ desc }}</span>
  </div>
</seds-modal>
